import { useTranslation } from 'react-i18next';
import { useLanguage } from '@/i18n/LanguageContext';

interface LogoProps {
  className?: string;
  showTagline?: boolean;
}

export function Logo({ className = '', showTagline = true }: LogoProps) {
  const { t } = useTranslation('auth');
  const { lang } = useLanguage();

  return (
    <div className={`flex items-baseline gap-2 ${className}`}>
      {showTagline && (
        <span className="text-[12px] text-[#565858]">
          {t('logo.tagline')}
        </span>
      )}
      <svg
        width="105"
        height="20"
        viewBox="0 0 105 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="relative top-[5px]"
      >
        <text
          x="0"
          y="16"
          fill="#0d0d0d"
          fontFamily="Manrope, sans-serif"
          fontSize="20"
          fontWeight="800"
          letterSpacing="-0.02em"
        >
          {lang === 'en' ? 'creator' : 'креатор'}
        </text>
      </svg>
    </div>
  );
}
